<template>
  <v-row align="center" justify="center">
    <v-col cols="12" sm="8" md="4">
      <v-card>
        <v-toolbar flat>
          <v-toolbar-title>assets.stormport-beta.nz</v-toolbar-title>
        </v-toolbar>
        <v-card-text>
          <v-form @submit="login">
            <v-text-field label="Login" name="login" type="text"></v-text-field>
            <v-text-field
              id="password"
              label="Password"
              name="password"
              type="password"
            />
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn light @click="login">Login</v-btn>
        </v-card-actions>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
export default {
  methods: {
    login() {
      this.$router.push({ name: "missions" });
    }
  }
};
</script>
